{
  "DATE_PICKER": {
    "APPLY_BUTTON": "Applica",
    "CLEAR_BUTTON": "Clear",
    "DATE_RANGE_INPUT": {
      "START": "Start Date",
      "END": "End Date"
    },
    "DATE_RANGE_OPTIONS": {
      "TITLE": "DATE RANGE",
      "TODAY": "Oggi",
      "YESTERDAY": "Ieri",
      "LAST_7_DAYS": "Ultimi 7 giorni",
      "LAST_30_DAYS": "Ultimi 30 giorni",
      "LAST_3_MONTHS": "Ultimi 3 mesi",
      "LAST_6_MONTHS": "Ultimi 6 mesi",
      "LAST_YEAR": "Ultimo anno",
      "CUSTOM_RANGE": "Intervallo di date personalizzato"
    }
  }
}
